import { useEffect, useRef, useState } from 'react'

// Master moved each bar segment to its new place and width over 200ms (a d3 transition, cubic
// in-out), so a mode or neutral-slider change reads as the bars sliding rather than jumping.
export const TWEEN_MS = 200

const easeCubicInOut = t => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2)

const sameGeometry = (a, b) => a.length === b.length && a.every((seg, i) => seg.x === b[i].x && seg.w === b[i].w)

// The segments as drawn: the first draw lands at once, and so does a resize (a new width rebuilt
// master's chart too); any other change eases each segment's x and width from where it is drawn.
export const useTweenedSegments = (target, width) => {
  const [shown, setShown] = useState(target)
  const shownRef = useRef(target)
  const widthRef = useRef(width)

  useEffect(() => {
    if (widthRef.current !== width || sameGeometry(shownRef.current, target)) {
      widthRef.current = width
      shownRef.current = target
      setShown(target)
      return
    }

    const from = shownRef.current
    let start = null
    let frame = requestAnimationFrame(function step(now) {
      if (null === start) start = now
      const t = Math.min(1, (now - start) / TWEEN_MS)
      const e = easeCubicInOut(t)
      const next = target.map((seg, i) => ({
        ...seg,
        x: from[i].x + (seg.x - from[i].x) * e,
        w: from[i].w + (seg.w - from[i].w) * e
      }))
      shownRef.current = next
      setShown(next)
      if (t < 1) frame = requestAnimationFrame(step)
    })

    return () => cancelAnimationFrame(frame)
  }, [target, width])

  return shown
}
